/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageModeSrcPanelFrameComponent } from './manage-mode-src-panel-frame.component';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { SelectSystemModule } from '../select-system';
import { SysqueContextMenuModule } from '../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { SelectCategoryModule } from '../select-category';
import { CategoryScopeModule } from '../category-scope';
import { RootPathSelectorModule } from '../root-path-selector';

@NgModule({
  declarations: [ManageModeSrcPanelFrameComponent],
  imports: [
    CommonModule,
    DxContextMenuModule,
    SelectSystemModule,
    SysqueContextMenuModule,
    SelectCategoryModule,
    CategoryScopeModule,
    RootPathSelectorModule
  ],
  exports: [ManageModeSrcPanelFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageModeSrcPanelFrameModule {}
